import { ThemeProvider } from "@mui/material";
import { DialogFooter } from "@src/appV2/redesign/components/DialogFooter";
import { LoadingButton } from "@src/appV2/redesign/components/LoadingButton";
import {
  BottomSheet,
  BottomSheetIllustrationContent,
  type UseModalState,
} from "@src/appV2/redesign/system/ui-components";
import { getTheme } from "@src/appV2/redesign/system/ui-theme";

interface Props {
  modalState: UseModalState;
  onLogout: () => Promise<void> | void;
  isLoading: boolean;
}

/**
 * Terminal dialog shown when a caller's identity maps to a soft-deleted
 * account whose `previousStage` is not on the reactivation allow-list
 * (e.g. RESTRICTED, DEACTIVATED). The only available action is Log out.
 */
export function AccountNotRestorableDialog(props: Props) {
  const { modalState, onLogout, isLoading } = props;

  return (
    <ThemeProvider theme={getTheme()}>
      <BottomSheet modalState={modalState}>
        <BottomSheetIllustrationContent
          illustrationType="warning"
          title="Account unavailable"
          description="This account has been deleted and can't be reactivated. If you think this is a mistake, please contact support."
        />
        <DialogFooter orientation="vertical">
          <LoadingButton
            fullWidth
            variant="contained"
            size="large"
            isLoading={isLoading}
            aria-label="Log out"
            onClick={async () => {
              await onLogout();
            }}
          >
            Log out
          </LoadingButton>
        </DialogFooter>
      </BottomSheet>
    </ThemeProvider>
  );
}
